module.exports = __webpack_public_path__ + "media/23.9766692f.wav";